import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Popup from "../../component/Popup/Popup.js";
import { changePassword } from "../../redux/action.js";
import { toast } from "react-toastify";
import PasswordInput from "../common/PasswordInput";

const ChangePassword = ({ open = true }) => {

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(open);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [strength, setStrength] = useState({
    level: "",
    color: "",
    width: "0%"
  });

  const closePopUp = () => {
    setIsOpen(false);
  };

  // Password strength checker
  const checkStrength = (password) => {

      const strongPassword =
      password.length >= 8 &&
      /[A-Z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

    if (!password) return { level: "", color: "", width: "0%" };

    if (password.length < 6 && !/[A-Z]/.test(password))
      return { level: "Weak", color: "#e53935", width: "33%" };
    if (strongPassword) {
      return { level: "Strong", color: "#43a047", width: "100%" };
    }
    //return { level: "Strong", color: "#43a047", width: "100%" };
    return { level: "Weak", color: "#e53935", width: "33%" };
  };

  const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

  if (password.length < minLength) {
    toast.error("Password must be at least 8 characters long.");
    return false;
  }
  if (!hasUpperCase) {
    toast.error("Password must contain at least one uppercase letter.");
    return false;
  }
  if (!hasNumber) {
    toast.error("Password must contain at least one number.");
    return false;
  }
  if (!hasSpecialChar) {
    toast.error("Password must contain at least one special character (e.g., !@#$%^&*).");
    return false;
  }
  
  return true;
};

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    if (name === "newPassword") {
      setStrength(checkStrength(value));
    }

    if (name === "confirmPassword") {
      if (value !== formData.newPassword) {
        setError("Passwords do not match");
      } else {
        setError("");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    // if (formData.newPassword.length < 8) {
    //   setError("Passwords length must be more or equal to 8");
    //   return;
    // }

    const isvalid = validatePassword(formData.newPassword);

    if(isvalid)
    dispatch(changePassword(formData))
    console.log("Password updated", formData);

    setFormData({
      newPassword: "",
      confirmPassword: "",
      userId: ""
    });

    setStrength("");
    setError("");
    setIsOpen(false);
  };

  return (
    // <Popup isOpen={isOpen} onClose={closePopUp}>
    <div>


      {/* <h3 style={{ marginBottom: "15px" }}>Change Password</h3> */}

      <form onSubmit={handleSubmit}>

        {/* New Password */}
        <div style={{ marginBottom: "12px" }}>
          <PasswordInput
            name="newPassword"
            placeholder="Enter New Password"
            aria-label="New password"
            autoComplete="new-password"
            toggleLabel="new password"
            value={formData.newPassword}
            onChange={handleChange}
            required
          />

          {strength.level && (
            <div style={{ marginTop: "6px" }}>

              <div
                style={{
                  height: "6px",
                  background: "var(--ui-surface-muted)",
                  borderRadius: "4px",
                  overflow: "hidden"
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: strength.width,
                    background: strength.color,
                    transition: "0.3s"
                  }}
                ></div>
              </div>

              <div
                style={{
                  fontSize: "12px",
                  marginTop: "4px",
                  color: strength.color
                }}
              >
                {strength.level} Password
              </div>

            </div>
          )}
        </div>

        {/* Confirm Password */}
        <div style={{ marginBottom: "12px" }}>
          <PasswordInput
            name="confirmPassword"
            placeholder="Confirm Password"
            aria-label="Confirm password"
            autoComplete="new-password"
            toggleLabel="confirm password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>

        {/* Error */}
        {error && (
          <div style={{ color: "var(--ui-danger-text)", fontSize: "13px", marginBottom: "10px" }}>
            {error}
          </div>
        )}

        <div class="password-requirements">
          <p>Password must be at least 8 characters long and include:</p>
          <ul class="no-bullets">
            <li>At least one uppercase letter</li>
            <li>At least one number</li>
            <li>At least one special character (e.g., !@#$%^&amp;*)</li>
          </ul>
        </div>

        <button type="submit" className="form-btn">
          Update Password
        </button>

      </form>
    </div>
    // {/* </Popup> */}
  );
};

export default ChangePassword;
